import {client} from '../helpers/api';

export async function getProfile() {
  const response = await client.get('/api/profile');

  if (response.data?.status) {
    const {data} = response.data;

    const profile = {
      userId: data?.profile.user_id,
      fullName: data?.profile.full_name,
      gradeName: data?.profile.grade_name,
      telegramLink: data?.profile.telegram_link,
      email: data?.profile?.u_email_id || data?.profile?.email_id,
      userType: data?.profile.user_type,
      contactNumber: data?.profile.contact_number,
      momContact: data?.profile.mom_contact,
      dadContact: data?.profile.dad_contact,
      schoolName: data?.profile.school_name,
      schoolType: data?.profile.school_type,
      address: data?.profile.address,
      postcode: data?.profile.postcode,
      state: data?.profile.state,
      city: data?.profile.city,
      userImage: data?.profile.user_image,
      gradeId: data?.profile.grade_id,
    };

    const kids =
      data?.kids.map(
        ({
          kid_id: id,
          _user_id: userId,
          _package_id: packageId,
          package_start_date: packageStartDate,
          package_exp_date: packageExpDate,
          student_name: studentName,
          gender,
          ic_number: icNumber,
          kids_image: kidsImage,
          grade: gradeId,
          dob,
          _transaction_id: transactionId,
        }) => ({
          id,
          userId,
          packageId,
          packageStartDate,
          packageExpDate,
          studentName,
          gender,
          icNumber,
          gradeId,
          dob,
          kidsImage,
          transactionId,
        }),
      ) || [];
    const result = {profile, kids};
    return result;
  }
  throw response;
}

// "profile": {
//   "user_id": "51438d73-041e-49b0-95a7-c74bc5b15967",
//   "first_name": "Mahyar2",
//   "last_name": "Abbasian2",
//   "u_email_id": "test@gmail.com",
//   "user_type": "student",
//   "contact_number": "+60176207703",
//   "address": null,
//   "postcode": null,
//   "state": "yoyo2",
//   "city": "test2",
//   "user_image": "default_avtar.png",
//   "date_created": "2021-01-09 21:31:43",
//   "date_modified": "2021-01-16 04:55:30"
// },
// "kids": [
//   {
//       "kid_id": "e6cfdf51-d611-4bbc-89b2-fd934d4a183e",
//       "_user_id": "51438d73-041e-49b0-95a7-c74bc5b15967",
//       "_package_id": "1082e459-9788-479a-9c59-5806457769eb",
//       "package_start_date": "2021-01-14",
//       "package_exp_date": "2021-03-14",
//       "student_name": "Manish Singh",
//       "gender": "Boy",
//       "ic_number": null,
//       "grade": "c6e482fb-e36b-4cc0-bd45-acaaf0f53723",
//       "dob": "2021-01-12T09:47:55.962Z",
//       "date_created": "2021-01-12 09:48:42",
//       "date_modified": "2021-01-14 23:04:56",
//       "status": "active",
//       "is_deleted": 0,
//       "_transaction_id": "0027d078-2440-4542-9f36-0010ef001081"
//   },
// ]
